<template>
  <div class="dropdown">
    <button
      class="dropdown__header"
      @focus="openDropdown"
      @blur="closeDropdown"
    >
      <span v-if="selected == null">
        {{ $t('favourites.sorting') }}
      </span>
      <span v-else>{{ selected }}</span>
      <div class="dropdown__icon">
        <Icon :tiny="true">
          <img src="@/assets/down.png" alt="" />
        </Icon>
      </div>
    </button>
    <ul class="dropdown__list" :class="{ active: opened }">
      <li
        class="dropdown__item"
        v-for="item in list"
        :key="item.value"
        @click="emitSelection(item.value, item.text)"
      >
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>

<script>
import Icon from '@/components/icon';

export default {
  name: 'dropdown',
  components: { Icon },
  data() {
    return { opened: false, selected: null };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    default: { default: null },
  },
  watch: {
    active(val) {
      this.opened = val;
    },
  },
  methods: {
    openDropdown() {
      this.opened = true;
    },
    closeDropdown() {
      setTimeout(() => {
        this.opened = false;
      }, 100);
    },
    emitSelection(value, text) {
      this.selected = text;
      this.$emit('selected', value);
    },
  },
  mounted() {
    this.selected = this.default;
    this.opened = this.active;
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  width: 100%;

  margin: {
    top: 6px;
    bottom: 6px;
  }
}

.dropdown__header {
  position: relative;
  z-index: 31;
  width: 100%;
  border: 1px solid $lightGray;
  background: #fff;
  border-radius: 20px;
  padding: 10px 11px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  text-transform: Capitalize;
  transition: 200ms;

  &:hover,
  &:focus,
  &.active {
    outline: none;
    border: 1px solid $primaryColor;
  }
}

.dropdown__icon {
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translateY(-50%);
}

.dropdown__list {
  position: absolute;
  z-index: 30;
  top: 50%;
  padding-top: 20px;

  width: calc(100%);

  border: 1px solid $lightGray;
  border-radius: 0 0 8px 8px;
  background: white;

  list-style-type: none;

  opacity: 0;
  visibility: hidden;

  &.active {
    opacity: 1;
    visibility: visible;
  }
}

.dropdown__item {
  border-top: 1px solid $lightGray;
  padding: 7px 12px;
  font-size: 12px;
  text-align: center;
  text-transform: capitalize;
  cursor: pointer;

  &:hover {
    background: $lighterGray;
  }
}
</style>
